import { takeLatest, put, call } from "redux-saga/effects";
import { FETCH_DOSSIER_REQUEST, REDIRECT_TO_LOGIN } from "./actionsTypes";
import {
  fetchDossierSuccess,
  fetchDossierFailure,
  redirectToLogin,
} from "./actions";
import axios from "axios";
import Config from "config";
function* fetchDossier(action) {
  // const { token} = action.payload;
  const api = Config.backOffice.apiName;
  const token = localStorage.getItem("auth_token_" + api);
  try {
    const response = yield axios.get(
      `https://www.fluxod.com/${api}/fdashboards/widget_dossiers_valides`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    yield put(fetchDossierSuccess(response.data));
  } catch (error) {
    yield put({ type: REDIRECT_TO_LOGIN });
  }
}

function* dossierSaga() {
  yield takeLatest(FETCH_DOSSIER_REQUEST, fetchDossier);
}

export default dossierSaga;
